











import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
@Component({
  name: 'Snackbar',
  components: {}
})
export default class Snackbar extends Vue {
  @PropSync('active', { default: false }) modelActive: boolean
  @Prop({ default: '' }) message!: string
  @Prop({ default: 10000 }) timeout!: number
  @Prop({ default: false }) multiline!: boolean
  @Prop({ default: true }) closeable!: boolean
}
